import { useEffect, useState } from "react";

export const useFetchProductSettingsCustomerPartNumbers = (sku) => {
    const [customerPartNumbers, setCustomerPartNumbers] = useState([]);

    useEffect(() => {
        const fetchCustomerPartNumbers = async () => {
            const rsp = await fetch(`api/products/${sku}/customerPartNumbers`);
            const customerPartNumbers = await rsp.json();

            setCustomerPartNumbers(customerPartNumbers);
        }
        fetchCustomerPartNumbers();
    }, [sku])

    return customerPartNumbers;
}

export const PutProductDistributorCustomerPartNumber = async (product, distributorRow) => {
    const requestOptions = {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(distributorRow.customerPartNumber ?? ""),
    };

    try {
        const response = await fetch(`api/products/${product.sku}/${distributorRow.id}/customerPartNumber`, requestOptions);
        if (!response.ok) {
            await response.json();
        }
    } catch (error) {
        console.error('Error:', error);
    }
}
